import type { FoaPart, ProcedureType } from "../../../../../autogen/bff-api";
import { isTwoStageProcedure } from "./procedure";

// These two helpers duplicate regulation constants that the BFF owns. Nothing breaks if they
// drift — the BFF still rejects a bad deadline — but the in-procedure tooltip and the summary
// footnote would silently mislead buyers. Keep them edited together with their BFF source:

// Mirrors StandstillRules.ELECTRONIC_STANDSTILL_DAYS / .daysFor:
// bff/domain/src/main/kotlin/no/sm/domain/domain/sourcingevent/v2/Standstill.kt
// Over-EØS procedures (Part III/IV) have a 10-day standstill (award notice is always delivered
// electronically); no standstill for other classifications.
export const autoKarensDays = (foaPart: FoaPart | null | undefined): number | null => {
  if (foaPart === "PART_III" || foaPart === "PART_IV") return 10;
  return null;
};

// Mirrors ProcedureRules / TenderDeadlineRules.minDaysFor:
// bff/domain/src/main/kotlin/no/sm/domain/domain/sourcingevent/v2/ProcedureRules.kt
// Only del III carries statutory minimums (FOA § 20-3): 30 days from the notice for
// single-stage, 25 days from the invitation for two-stage. Del II has no fixed minimum
// (§ 8-14, proportionality only).
export const minTenderDays = (
  foaPart: FoaPart | null | undefined,
  procedureType?: ProcedureType | null,
): number | null => {
  if (foaPart !== "PART_III") return null;
  return isTwoStageProcedure(procedureType) ? 25 : 30;
};

// FOA § 20-3: minimum deadline for requests to participate (two-stage, del III only).
export const minRequestDays = (
  foaPart: FoaPart | null | undefined,
  procedureType: ProcedureType | null | undefined,
): number | null =>
  foaPart === "PART_III" && isTwoStageProcedure(procedureType) ? 30 : null;

// Mirrors ProcedureRules.minCandidatesWhenCapped (FOA § 16-12 (3)): when the buyer caps the
// number of invited candidates, begrenset anbudskonkurranse requires at least 5 and the
// negotiated family 3. Null = capping not applicable to the procedure.
export const minCandidatesWhenCapped = (
  foaPart: FoaPart | null | undefined,
  procedureType: ProcedureType | null | undefined,
): number | null => {
  if (foaPart !== "PART_III" || !isTwoStageProcedure(procedureType)) return null;
  return procedureType === "RESTRICTED" ? 5 : 3;
};
